import { Navigate } from 'react-router'

import { isSpenderOnlyRole } from '@ankor-io/common/domain/iam/account'
import { AwxConnectedAccountType } from '@ankor-io/common/types/awx'
import { Loading } from '@ankor-io/ui-components/src/Loading'

import { useConnectedAccount } from '@/providers/connectedAccount'
import { useUserContext } from '@/providers/user/useUserContext'

/**
 * Redirects to the correct module dashboard based on the active connected account type.
 */
export function ModuleRedirect() {
  const { activeConnectedAccountId, activeOrganizationRole } = useUserContext()
  const { connectedAccounts, isLoading } = useConnectedAccount()

  if (isLoading) {
    return <Loading />
  }

  const active = connectedAccounts.find((a) => a.id === activeConnectedAccountId)

  if (connectedAccounts.length === 0) {
    return <div>No vessel found</div>
  }

  const isSpender = isSpenderOnlyRole(activeOrganizationRole)

  if (active?.type === AwxConnectedAccountType.OPERATIONS) {
    return (
      <Navigate
        to={isSpender ? '/ops/transactions' : '/ops/dashboard'}
        replace
      />
    )
  }

  // Default to APA if APA type, or no type resolved
  return (
    <Navigate
      to={isSpender ? '/apa/transactions' : '/apa/dashboard'}
      replace
    />
  )
}
